import moment from 'moment';
import { getLocalStorageItem } from '../../../../services/localStorageUtils';

export const expiryTimeCalculation = () => {
  const expTimeFromDatabase = getLocalStorageItem('OtpExp');

  const expTimeFromDatabaseUtc = moment.utc(expTimeFromDatabase);
  //   Function to check if a given moment object is in UTC format
  // function isUTC(momentObj) {
  //   return momentObj.utcOffset() === 0;
  // }
  // Get the current local time
  const timeFromLocalMachine = moment().utc();

  // Check if both times are in UTC format
  // const isExpiryTimeUTC = isUTC(expTimeFromDatabaseUtc);
  // const isLocalTimeUTC = isUTC(timeFromLocalMachine);

  // Calculate the difference in milliseconds between the two times
  const timeDifferenceInMilles = Math.abs(
    expTimeFromDatabaseUtc.valueOf() - timeFromLocalMachine.valueOf(),
  );
  // Convert the difference in milliseconds to hh:mm:ss format
  const duration = moment.duration(timeDifferenceInMilles);
  const hours = Math.floor(duration.asHours());
  const minutes = Math.floor(duration.asMinutes()) % 60;
  const seconds = Math.floor(duration.asSeconds()) % 60;
  // Construct the formatted difference string in hh:mm:ss format
  return `${hours}:${minutes}:${seconds}`;
};

export const calculateTotalSeconds = (time) => {
  const [hoursStr, minutesStr, secondsStr] = time.split(':');

  if (minutesStr !== '0' && hoursStr === '0') {
    return parseInt(minutesStr) * 60 + parseInt(secondsStr);
  }
  if (hoursStr !== '0') {
    return (
      parseInt(hoursStr) * 3600 +
      parseInt(minutesStr) * 60 +
      parseInt(secondsStr)
    );
  }
  return parseInt(secondsStr);
};
